$(document).ready(function(){
  $('.review-data').slick({
    dots: false,
  infinite: false,
  speed: 300,
    adaptiveHeight:true,
  slidesToShow: 1
   

  });
//   $('.main-conatcat-form .action_button').on('click',function{
//                               debugger;
//                               $('.popup-overlay').addClass('page-none');
//                               });
  
});
